import { createFileRoute, useParams } from '@tanstack/react-router';

import { QuizInfoView } from '@/views/quizzes/quiz-info-view.tsx';

// Quiz 信息 / 作答前页面（详情、特殊访问、我的尝试、开始按钮）。
export const Route = createFileRoute('/_learner/courses_/$id/quizzes/$quizId/')({
  component: QuizInfoPage,
});

function QuizInfoPage() {
  const { id, quizId } = useParams({ from: '/_learner/courses_/$id/quizzes/$quizId/' });
  return <QuizInfoView courseId={id} quizId={quizId} />;
}
